import React, { useState } from "react";
import {
  Box,
  LinearProgress,
  Tabs,
  Tab,
  List,
} from "@material-ui/core";
import { DataGrid, ColDef } from "@material-ui/data-grid";
import { observer } from "mobx-react-lite";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import { dateStr } from "../../utils";
import { UserPreviewData } from "../../types/UserPreviewData";

function tapsStyles() {
  return {
    indicator: {
      backgroundColor: "#fff",
    },
  };
}

function dataGridStyles() {
  return {
    root: {
      color: "inherit",
      borderWidth: 0,
    },
  };
}

export const DeviceHistoryDatagrid = observer(
  ({
    mode,
    data: {
      loading,
      result_temp_history,
      result_oximeter_history,
      result_heart_rate_history,
      result_blood_pressure_history,
      result_battery_history,
      result_wearing_history,
      result_locations_history,
      result_breath_history,
      result_blood_sugar_history
    },
  }: {
    mode?: string;
    data: UserPreviewData;
  }) => {
    const { userId }: any = useParams();
    const classesTab = makeStyles(tapsStyles)();
    let TYPES :any;
    if(localStorage.getItem('projectType') === "SI"){
      TYPES = [
        {
          name: "Tempurature",
          field: "body_temp",
          data: result_temp_history || [],
        },
        {
          name: "Heart Rate",
          field: "heart_rate",
          data: result_heart_rate_history || [],
        },
        {
          name: "Blood pressrue",
          field: "blood_pressure",
          data: result_blood_pressure_history || [],
        },
        {
          name: "SPO2",
          field: "oxygen",
          data: result_oximeter_history || [],
        },
        {
          name: "Breath",
          field: "breath",
          data: result_breath_history || [],
        },
        {
          name: "Blood Sugar",
          field: "blood_sugar",
          data: result_blood_sugar_history || [],
        }];
    }else if(localStorage.getItem('projectType') === "isolation"){
      TYPES = [
        {
          name: "Tempurature",
          field: "body_temp",
          data: result_temp_history || [],
        },
        {
          name: "Heart Rate",
          field: "heart_rate",
          data: result_heart_rate_history || [],
        },
        {
          name: "Blood pressrue",
          field: "blood_pressure",
          data: result_blood_pressure_history || [],
        },
        {
          name: "SPO2",
          field: "oxygen",
          data: result_oximeter_history || [],
        },
        {
          name: "Respiration",
          field: "breath",
          data: result_breath_history || [],
        },
        {
          name: "Blood Sugar",
          field: "blood_sugar",
          data: result_blood_sugar_history || [],
        }];
    }else {
      TYPES = [
        {
          name: "Tempurature",
          field: "body_temp",
          data: result_temp_history || [],
        },
        {
          name: "Heart Rate",
          field: "heart_rate",
          data: result_heart_rate_history || [],
        },
        {
          name: "Blood pressrue",
          field: "blood_pressure",
          data: result_blood_pressure_history || [],
        },
        {
          name: "SPO2",
          field: "oxygen",
          data: result_oximeter_history || [],
        },
        {
          name: "Battery",
          field: "battery",
          data: result_battery_history || [],
        },
        {
          name: "Wearing status",
          field: "device_status",
          data: result_wearing_history || [],
        },
        {
          name: "Location(Lat,Long)",
          field: "location",
          data: result_locations_history || [],
        }
      ];
    }
    

    const [t, setType] = useState(TYPES[0].name);
    const [valueTabs, setValueTabs] = useState(0);
    const selected: any = TYPES[TYPES.map(({ name } : {name: any}) => name).indexOf(t)];
    const columns: ColDef[] = [
      { field: "timeStamp", width: 200 },
      { field: selected.field, width: 200 },
      // { field: "length_of_stay", headerName: "length_of_stay", width: 200 },
    ];
    const data = (selected.data || []).map(({ ...d }) => {
      if(d.device_status){
        if(d.device_status === 1){
          d.device_status = "Low Battery";
        }else if(d.device_status === 2){
          d.device_status = "SOS";
        }else if(d.device_status === 3){
          d.device_status = "Power Off";
        }else if(d.device_status === 4){
          d.device_status = "Take Off";
        }else if(d.device_status === 5){
          d.device_status = "Sedentary";
        }else if(d.device_status === 6 ){
          d.device_status = "Vibration";
        }else if(d.device_status === 7){
          d.device_status = "Wear On";
        }else if(d.device_status === 8){
          d.device_status = "Open Alarm";
        }else if(d.device_status === 9){
          d.device_status = "Charging";
        }else if(d.device_status === 10){
          d.device_status = "Discharge";
        }else if(d.device_status === 11){
          d.device_status = "Check In";
        }else if(d.device_status === 12){
          d.device_status = "Check Out";
        }else if(d.device_status === 13){
          d.device_status = "Manual Diasble SOS";
        }else if(d.device_status === 14){
          d.device_status = "Server Disable SOS";
        }else if(d.device_status === 15){
          d.device_status = "Cut Off Strap";
        }else if(d.device_status === 16){
          d.device_status = "Disassemble Buckle";
        }else if(d.device_status === 17){
          d.device_status = "Charging Full";
        }else{
          d.device_status = "";
        }
      }
      return { ...d, id: d.timestamp, timeStamp: dateStr(d.timestamp) };
    });
    
    const handleChangeTabs = (
      event: React.ChangeEvent<{}>,
      newValue: number
    ) => {
      console.log("handleChangeTabs", TYPES[newValue].name);
      setValueTabs(newValue);
      setType(TYPES[newValue].name);
    };
    return (
      <Box
        css={{
          borderRadius: 5,
          backgroundColor: "#3D6BAF",
          color: "#fff",
          height: "calc(100vh - 10rem)",
        }}
      >
        {loading && (
          <LinearProgress
            style={{ position: "absolute", top: 0, left: 0, width: "100%" }}
          />
        )}

        <Tabs
          value={valueTabs}
          textColor="inherit"
          variant="scrollable"
          onChange={handleChangeTabs}
          css={{ paddingTop: 10 }}
          classes={{
            indicator: classesTab.indicator,
          }}
        >
          {TYPES.map(({ name } : {name: any}) => (
            <Tab
              label={name}
              css={{
                borderBottom: "1px solid rgba(255,255,255,0.5)",
              }}
              key={Math.random()}
            />
          ))}
        </Tabs>
        
        <Box
          css={{
            width: "100%",
            height: "85%",
            // height: "calc(100vh - 10rem)",
            overflow: "scroll",
            "::-webkit-scrollbar": {
              display: "none",
            },
            " .MuiDataGrid-root": {
              borderWidth: 0,
              color: "inherit",
            },
          }}
          mt={2}
          px={2}
          id="tableDeviceHistoryDatagrid"
        >
          <List css={{maxHeight: '100%', overflow: 'auto', height: '100%'}}>
            <DataGrid
              rows={data || []}
              columns={columns}
              // pageSize={21}
              pagination
              disableSelectionOnClick={true}
              headerHeight={0}
              autoHeight={true}
              scrollbarSize={0}
              rowHeight={37}
              hideFooterPagination={true}
              hideFooterRowCount={true}
              // loading={true}
              // rowsPerPageOptions={[20, 50, 100]}
              // density="compact"
              // autoPageSize={true}
            />
          </List>
        </Box>
      </Box>
    );
  }
);
